import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { measurementAndPolicyDefaultValues, productDetailsDefaultValues } from '../../Pages/Products/Utils/ReuseVariableHelper/ResuseVariable';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Dimensions {
  length: number;
  breadth: number;
  height: number;
  uom: string;
}


interface UploadImagesAndCategory {
  thumbnail: string;
  productImages: string[];
}

interface ManufacturerDetails {
  manufacture_name: string,
  manufacture_date: string;
  categorizedDetail?: Record<string, any>;
  customFields: Record<string, Record<string, any>>
}

interface Attribute {
  name: string;
  price: string;
  sale_price: string;
  barcode: string;
  image: string;
}

interface AttributeDetails {
  attributes: any;
  attriValues: any;
  productPrice: number;
  is_variant: boolean;
  selected_attributes_list:number[];
  selected_variants: number[];
  salePrice: number;
  gstPercent: number;
  discount: number;
  variant: Attribute[];
}

interface MetaDetails {
  metaTitle: string;
  metaDescription: string;
  metaImages: string;
}

interface ProductState {
  createdProductID:number,
  productStoreDetail:Record<string, any>;
  productDetails: ProductFormValues & MeasurementAndPolicyValues;
  uploadImagesAndCategory: UploadImagesAndCategory;
  manufacturerDetails: ManufacturerDetails;
  attributeDetails: AttributeDetails;
  metaDetails: MetaDetails;
  getApiData: any[];
  isVariant:boolean;
  is_addon_item:boolean;
}

const initialState: ProductState = {
  createdProductID:0,
  productStoreDetail: {},
  productDetails:{...productDetailsDefaultValues,...measurementAndPolicyDefaultValues},
  uploadImagesAndCategory: {
    thumbnail: '',
    productImages: []
  },
  manufacturerDetails: {
    manufacture_name: "",
    manufacture_date: '',
    categorizedDetail: {},
    customFields: {}
  },
  attributeDetails: {
    productPrice: 0,
    salePrice: 0,
    gstPercent: 0,
    discount: 0,
    is_variant: false,
    selected_attributes_list: [],
    selected_variants: [],
    variant: [],
    attributes: undefined,
    attriValues: undefined
  },
  metaDetails: {
    metaTitle: '',
    metaDescription: '',
    metaImages: ''
  },
  getApiData: [],
  isVariant:false,
  is_addon_item:false
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProductStoreDetails: (state, action: PayloadAction<Record<string, any>>) => {
      state.productStoreDetail = { ...state.productStoreDetail, ...action.payload };
    },
    setShowVariant:(state,action:PayloadAction<boolean>)=>{
      state.productDetails.have_variant = action.payload;
    },
    setShowCombination:(state,action:any)=>{
      state.productDetails.is_addon_item = action.payload;
    },
    setProductDetails: (state, action: PayloadAction<Partial<ProductFormValues>>) => {
      state.productDetails = { ...state.productDetails, ...action.payload };
    },
    setUploadImagesAndCategory: (state, action: PayloadAction<Partial<UploadImagesAndCategory>>) => {
      state.uploadImagesAndCategory = { ...state.uploadImagesAndCategory, ...action.payload };
    },
    setManufacturerDetails: (state, action: PayloadAction<Partial<ManufacturerDetails>>) => {
      state.manufacturerDetails = { ...state.manufacturerDetails, ...action.payload };
    },
    updateAttributes: (state, action: PayloadAction<Partial<AttributeDetails>>) => {
      state.attributeDetails = { ...state.attributeDetails, ...action.payload };
    },
    updateMetaDetails: (state, action: PayloadAction<Partial<MetaDetails>>) => {
      state.metaDetails = { ...state.metaDetails, ...action.payload };
    },
    setApiData: (state, action: PayloadAction<any[]>) => {
      state.getApiData = action.payload;
    },
    setCreatedProductID:(state,action:PayloadAction<any>)=>{
      state.createdProductID = action.payload;
    },
    resetProductValues: () => initialState
  }
});

export const { setProductDetails, 
  setUploadImagesAndCategory, 
  setManufacturerDetails, 
  updateAttributes, 
  updateMetaDetails, 
  setApiData, 
  resetProductValues,
  setProductStoreDetails,
  setCreatedProductID,
  setShowVariant,
  setShowCombination
} = productSlice.actions;
export default productSlice.reducer;

export const selectProductDetails = (state: { product: ProductState }) => state.product.productDetails;
export const selectUploadImagesAndCategory = (state: { product: ProductState }) => state.product.uploadImagesAndCategory;
export const selectManufacturerDetails = (state: { product: ProductState }) => state.product.manufacturerDetails;
export const selectAttributeDetails = (state: { product: ProductState }) => state.product.attributeDetails;
export const selectMetaDetails = (state: { product: ProductState }) => state.product.metaDetails;